import type { Role } from '@/entities/user';

export const supportAccessRoles = ['admin'] as const satisfies readonly Role[];
